/* @flow */
import React, { Component } from 'react';
import { TableRow, TableRowColumn } from 'material-ui/Table';
import Avatar from 'material-ui/Avatar';
import ListItem from 'material-ui/List/ListItem';
import RaisedButton from 'material-ui/RaisedButton';
import { graphql, createFragmentContainer } from 'react-relay';

import type { JobRequestOffers_request } from './__generated__/JobRequestOffers_request.graphql';
import ConfirmDialog from '../../components/ConfirmDialog';
import { Grid } from '../../../components';
import TimeSlot from './TimeSlot';
import JobOfferStatus from './JobOfferStatus';

type Props = {
  request: JobRequestOffers_request,
  handleForceAccept: string => void,
};

class JobRequestOffers extends Component<Props> {
  renderRow = ({ id, tutor, totalRateTutor, sessions, status }) => (
    <TableRow key={id}>
      <TableRowColumn>
        <ListItem
          disabled
          leftAvatar={<Avatar src={tutor.profilePictureUri} />}
        >
          <span>{`${tutor.firstname} ${tutor.lastname}`}</span>
        </ListItem>
      </TableRowColumn>
      <TableRowColumn>{totalRateTutor}</TableRowColumn>
      <TableRowColumn>
        {tutor.rating.average} average, {tutor.rating.count} count
      </TableRowColumn>
      <TableRowColumn>
        {sessions.map(({ timeSlot }) => (
          <TimeSlot key={timeSlot.id} timeSlot={timeSlot} />
        ))}
      </TableRowColumn>
      <TableRowColumn>
        <JobOfferStatus status={status} />
      </TableRowColumn>
      <TableRowColumn>
        <ConfirmDialog
          title="Force Accept"
          handleSubmit={() => this.props.handleForceAccept(id)}
          renderSubmitButton={handleButtonClick => (
            <RaisedButton
              label="Force Accept"
              primary
              onClick={handleButtonClick}
            />
          )}
        />
      </TableRowColumn>
    </TableRow>
  );

  render() {
    const { request } = this.props;

    const headers = [
      'Tutor',
      'Rate',
      'Rating',
      'Time Slot',
      'Status',
      'Actions',
    ];

    return (
      <div>
        <Grid
          headers={headers}
          renderRow={this.renderRow}
          rows={request.offers}
        />
      </div>
    );
  }
}

export default createFragmentContainer(JobRequestOffers, {
  request: graphql`
    fragment JobRequestOffers_request on JobRequest {
      offers(status: $jobOfferStatus) {
        id
        tutor {
          firstname
          lastname
          profilePictureUri
          rating {
            average
            count
          }
        }
        totalRateStudent
        totalRateTutor
        sessions {
          timeSlot {
            id
            ...TimeSlot_timeSlot
            startDate
            duration {
              hours
              minutes
            }
          }
        }
        createdAt
        status
      }
    }
  `,
});



// WEBPACK FOOTER //
// ./src/modules/job/components/JobRequestOffers.js